// extracted by mini-css-extract-plugin
module.exports = {"btnLink":"ButtonLink_btnLink__22PEA","primary":"ButtonLink_primary__1la94","ghost":"ButtonLink_ghost__29Tln"};